module.exports = __webpack_public_path__ + "img/officialSwiper2.fd19a6e1.png";